import React from 'react';
import { Box } from '@mui/material';
import { filterItemSx, filterItemWithWidthSx } from '../../../styles';

/**
 * FilterItem - A wrapper for individual filter components within a FilterSection
 *
 * @param {number} width - Optional fixed width in pixels
 * @param {Object} sx - Additional sx props to merge
 * @param {React.ReactNode} children - The filter component to render
 */
function FilterItem({ width, sx = {}, children }) {
  const baseSx = width ? filterItemWithWidthSx(width) : filterItemSx;

  return (
    <Box sx={{ ...baseSx, ...sx }}>
      {children}
    </Box>
  );
}

export default FilterItem;
